import type { LayoutSpec } from '../../../../types/LayoutConfig';
import { DEFAULT_LAYOUT_ID } from '../tokens';
import { DEFAULT_TRADING_LAYOUT } from './DefaultTrading';
import { WATCHLIST_CONSTRAINTS } from './shared';

export const DEFAULT_TRADING_LAYOUT_SPEC: LayoutSpec = {
  templateId: DEFAULT_LAYOUT_ID,
  label: 'Markets',
  id: DEFAULT_LAYOUT_ID,
  dockViewLayout: DEFAULT_TRADING_LAYOUT,
  constraints: [WATCHLIST_CONSTRAINTS],
  collapsablePanels: [
    {
      groupId: 'watchlists',
      direction: 'left' as const,
      buttonLabel: 'Watchlist',
    },
  ],
};
